import React from 'react';
import { useCommon } from 'src/domains/common/Common';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { BetGliderState } from 'src/domains/sportsbook/state/betGliderState/BetGliderState';
import { observer } from 'src/utils/mobx-react';
import {
    BetGliderIframe,
    IframeContainer,
    ModalWrapper,
} from 'src/domains/sportsbook/webview/components/betGliderModal/BetGliderModal.style';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';

export const BetGliderModal = observer('BetGliderModal', (): JSX.Element | null => {
    const common = useCommon();
    const betGliderState = BetGliderState.get(common);
    const breakpointsState = BreakpointsState.get(common);
    const appLayoutsState = AppLayoutsState.get(common);
    const starRouter = StarRouter.get(common);
    const isAccountsOpened = starRouter.accountView !== null;

    const isMobile = breakpointsState.tablet.isBiggerOrEq === false;
    const { boxHeight: bannersHeight } = appLayoutsState.bannersBoxState;

    if (betGliderState.url === '' || isMobile === false) {
        return null;
    }

    return (
        <ModalWrapper
            data-test='bet-glider-modal'
            bannersHeight={bannersHeight}
            isAccountsOpened={isAccountsOpened}
        >
            <IframeContainer>
                <BetGliderIframe
                    title='bet-glider-modal'
                    src={betGliderState.url}
                    onMessage={betGliderState.onIframeMessage}
                    dataTest='bet-glider-iframe'
                />
            </IframeContainer>
        </ModalWrapper>
    );
});
